import UserDistinguish from './index';

export default { path: '/home/market/delegation/user/distinguish', component: UserDistinguish };